/**
 * 画像URLのヘルパー関数
 * Cloudinary画像（完全URL）とローカル画像パスの両方に対応
 */

/**
 * 画像URLを取得（Cloudinary対応 + プロキシ対応）
 * @param {string} imageUrl - 画像URL（相対パスまたは完全URL）
 * @param {string} apiUrl - APIベースURL（デフォルトは環境変数から取得）
 * @returns {string} - 完全な画像URL
 */
export const getImageUrl = (imageUrl, apiUrl) => {
  if (!imageUrl) return '';

  const API_URL =
    apiUrl ||
    (typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
      ? (import.meta.env.VITE_API_URL || 'https://registration-app-production.up.railway.app')
      : 'http://localhost:3000');

  // 既にプロキシURLの場合
  if (imageUrl.includes('/api/images/proxy?url=')) {
    // 🔧 修正: バックエンドがhttp://で返した場合、https://に修正
    if (
      imageUrl.startsWith('http://registration-app-production.up.railway.app')
    ) {
      return imageUrl.replace('http://', 'https://');
    }
    return imageUrl;
  }

  // コロン抜けURLの修正（https// → https://）
  if (imageUrl.startsWith('https//') || imageUrl.startsWith('http//')) {
    imageUrl = imageUrl.replace(/^(https?)\/\//, '$1://');
  }

  // 完全URLの場合はそのまま返す（バックエンドで既にプロキシURL変換済み）
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // 相対パスの場合はAPI_URLを付ける（ローカル画像）
  return `${API_URL}${imageUrl}`;
};

/**
 * プロフィール画像URLを取得（デフォルト画像対応）
 * @param {string} imageUrl - 画像URL
 * @param {string} apiUrl - APIベースURL
 * @param {string} defaultImage - デフォルト画像URL（オプション）
 * @returns {string} - 完全な画像URL
 */
export const getProfileImageUrl = (
  imageUrl,
  apiUrl,
  defaultImage = '/default-avatar.png'
) => {
  if (!imageUrl) return defaultImage;
  return getImageUrl(imageUrl, apiUrl);
};
